import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import skillDetails from './SkillDetails';
import SkillPopover from './SkillPopover';

const Mobile = () => {
  const [activeSkill, setActiveSkill] = useState(null);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });

  const skillAnimation = {
    hidden: { opacity: 0, x: -50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1 + 0.8, // Menambah delay base 0.8s
        duration: 0.5,
        type: "spring",
        stiffness: 100
      }
    })
  };

  const skills = [
    { name: 'Flutter', level: 'Advanced' },
    { name: 'Swift', level: 'Intermediate' },
    { name: 'React Native', level: 'Intermediate' },
    { name: 'Kotlin', level: 'Basic' }
  ];

  const getSkillDetails = (skillName) => {
    return skillDetails.find(skill => skill.title === skillName)?.details || [];
  };

  const handleMouseEnter = (e, skillName) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    
    // Calculate position based on screen width
    let xPos;
    if (screenWidth <= 768) {
      xPos = screenWidth / 2; // Center for mobile
    } else {
      xPos = rect.right + 20; // 20px gap from skill item
      if (xPos + 320 > screenWidth) { // If popover would go off screen
        xPos = rect.left - 320; // Show on left side instead
      }
    }

    setPopoverPosition({
      x: xPos,
      y: window.scrollY + rect.top, // Account for scroll position
    });
    setActiveSkill(skillName);
  };

  return (
    <motion.div 
      className='skills__content'
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400 }}
    >
      <motion.h3 
        className="skills__title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Mobile Developer
      </motion.h3>

      <br />

      <div className="skills__box">
        <div className="skills__group">
          {skills.map((skill, index) => (
            <motion.div 
              className="skills__data" 
              key={index}
              variants={skillAnimation}
              initial="hidden"
              whileInView="visible"
              custom={index}
              onMouseEnter={(e) => handleMouseEnter(e, skill.name)}
              onMouseLeave={() => setActiveSkill(null)}
              style={{ position: 'relative', cursor: 'pointer' }}
            >
              <i className="uil uil-check-circle" />
              <div>
                <motion.h3 
                  className="skills__name"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2 * index }}
                >
                  {skill.name}
                </motion.h3>
                <motion.span 
                  className="skills__level"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3 * index }}
                >
                  {skill.level}
                </motion.span>
              </div>
              <AnimatePresence>
                {activeSkill === skill.name && (
                  <SkillPopover 
                    details={getSkillDetails(skill.name)}
                    position={popoverPosition}
                  />
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Mobile;
